import { useEffect, useState } from "react";
import { Button, Dropdown, Space } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { PieChartProjectLeaders } from "../../../components/Graphics/PieChartProjectLeaders";
import CardDetailProject from "../../../components/Card/CardDetailProject";
import { ContainerCardsSymbology } from "../../../components/container";
import { ToggleSectionButton } from "../../../components/Buttons";
import { colorsSizeProject } from "../../../types/schemesColors";
import { getLeaderProjectsByYear } from "../../../config";
import { LeadersTable } from "./LeadersTable";
import useYear from "../../../hooks/Year";

const LeaderTab = ({ sections, handleSectionChange, selectedSection, projectSize }) => {
    const { listOfYears, updateYear, year } = useYear(5);
    const [leaderProjects, setLeaderProjects] = useState([]);
    const [leaderData, setLeaderData] = useState([]);

    useEffect(() => {
        getLeaderProjectsByYear(year).then((response) => {
            const { leaders } = response.payload;
            setLeaderProjects(leaders);
        });
    }, [year]);

    const getChildLeaderData = ({ size, fatherIndex, index }) => {
        const sizeLowerCase = String(size.name).toLocaleLowerCase();
        const sizeColor = colorsSizeProject.find((size) => size.name === sizeLowerCase);
        return {
            name: `${fatherIndex}-${index}-${size.name}`,
            label: size.name,
            total: size.total,
            color: sizeColor ? sizeColor.color : "#fffff",
        };
    }

    const getTableLeaderData = (leader, index) => {
        const { name, sizes = [], color = "#fffff" } = leader;
        const children = sizes.map((size, i) => { return getChildLeaderData({ size, fatherIndex: index, index: i }) });
        return {
            name,
            color,
            label: name,
            children,
        };
    }
    useEffect(() => {
        const res = leaderProjects.map(getTableLeaderData);
        res.sort((a, b) => a.name.localeCompare(b.name));
        setLeaderData(res);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [leaderProjects]);

    return (
        <CardDetailProject
            title="Gráfica-Cantidad de Proyectos divididos operativamente"
            titleClass="sm:w-[calc(100%-108px)] md:w-[calc(100%-180px)]"
            headerChildren={
                <>
                    <span>
                        <Dropdown
                            menu={{ items: listOfYears, onClick: (data) => updateYear(data.key) }}
                            className="flex items-center justify-center w-[62px] h-[22px] text-xs "
                        >
                            <Button>
                                <Space>
                                    {year}
                                    <DownOutlined />
                                </Space>
                            </Button>
                        </Dropdown>
                    </span>

                    <div className="w-full md:w-max">
                        <ToggleSectionButton sections={sections} handleSectionChange={handleSectionChange} selectedSection={selectedSection} />
                    </div>
                </>
            }
        >
            <section className="w-full">
                <div
                    className={`w-full mt-4 md:mt-8 flex flex-col xl:flex-row justify-center xl:justify-around items-center gap-6 md:gap-4 lg:gap-10 ${selectedSection === 1 ? "block" : "hidden"
                        }`}
                >
                    <PieChartProjectLeaders leaderData={leaderData} />
                    <div className="grid xl:auto-rows-min gap-4 md:[grid-template-areas:'size_other''leader_none'] xl:[grid-template-areas:'size''leader''other']">
                        <ContainerCardsSymbology
                            extraClass="md:[grid-area:size]"
                            title="Horas del proyecto"
                            data={projectSize}
                            labelName="label"
                            conditionalFilter={(label) => label === "E" || label === "F"}
                            customProp="label"
                        />
                        <ContainerCardsSymbology
                            extraClass="md:max-w-fit md:[grid-area:other]"
                            title="Otras categorías"
                            data={projectSize}
                            labelName="label"
                            conditionalFilter={(label) => !(label === "E" || label === "F")}
                            customProp="label"
                        />
                        <ContainerCardsSymbology
                            title="Líderes"
                            data={leaderData}
                            labelName="name"
                            labelBold={true}
                            extraClass="md:[grid-area:leader]"
                            childWith="w-[80px] xl:w-[100px]"
                        />
                    </div>
                </div>
                <div className={`mt-5 md:mt-2 ${selectedSection === 0 ? "block" : "hidden"}`}>
                    <LeadersTable leaderProjects={leaderProjects} />
                </div>
            </section>
        </CardDetailProject>
    );
};

export default LeaderTab;
